import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { loadFont } from 'loankeeper-common/helpers/styles'
import { PageTabButton } from 'loankeeper-common/components'
import { actions as LKModalActions } from 'shared/LKModal'
import LKModal from '../shared/LKModal/LKModal'

const ButtonWrapper = styled(PageTabButton)`
  &.ui.buttons {
    border: 1px solid transparent};
    background: var(--color-window-background-header) !important;

    .ui.button {
      background: var(--color-window-background-header) !important;
    }

    .lk-button-icon img {
      width: 15px;
      vertical-align: middle;
    }

    *:not(i) {
      ${(props) => loadFont(props.theme.openedWindowButtonsFont)};
    }
  }

  &.ui.buttons.active,
  &.ui.buttons:hover {
    border-color: var(--color-window-button-hover) !important;
  }
`

const TabButton = ({ active, name, shortName, onOpen, icon, uri, onClose }) => {
  const dispatch = useDispatch()

  const needsConfirmationToClose = ['/secure/reporting', '/secure/account/turnover'].indexOf(uri) !== -1

  const handleClose = React.useCallback(() => {
    if (needsConfirmationToClose) {
      dispatch(LKModalActions.openConfirmation('CLOSE_CONFIRMATION'))
    } else {
      onClose()
    }
  }, [needsConfirmationToClose, onClose, dispatch])

  return (
    <>
      {needsConfirmationToClose && <LKModal.Confirmation name="CLOSE_CONFIRMATION" onConfirm={onClose} />}
      <ButtonWrapper active={active} alias={icon} onClick={onOpen} onClose={handleClose}>
        {shortName || name}
      </ButtonWrapper>
    </>
  )
}

export default TabButton
